<template>
  <cos-modal
    v-model:visible="visible"
    :title="editForm.id ? t('btn.edit') : t('btn.add')"
    width="600px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="editForm" ref="formRef" v-if="visible" autocomplete="off">
      <a-form-item
        name="manageAreaId"
        :label="t('operate.mzmxr7')"
        :rules="[{ required: true, message: t('common.pleaseSelect') }]"
      >
        <CustomerAreaCascader appId="cos_ofbu" v-model:value="editForm.manageAreaId" :disabled="editForm.id" />
      </a-form-item>
      <a-form-item
        name="seller"
        :label="t('operate.y20bdt')"
        :rules="[{ required: true, message: t('common.pleaseSelect') }]"
      >
        <UserSelect v-model:value="editForm.seller" allowClear :disabled="editForm.id" />
      </a-form-item>
      <a-form-item name="clueNum" :label="t('operate.rn82s1')">
        <a-input-number
          v-model:value="editForm.clueNum"
          :min="0"
          :precision="0"
          :max="999999"
          :placeholder="t('common.pleaseInput')"
        />
      </a-form-item>
      <a-form-item name="customerContractNum" :label="t('operate.px4c2i')">
        <a-input-number
          v-model:value="editForm.customerContractNum"
          :precision="0"
          :min="0"
          :max="999999"
          :placeholder="t('common.pleaseInput')"
        />
      </a-form-item>
      <!-- <a-form-item name="customerDealAmount" :label="t('operate.2cy4dq')">
        <a-input-number
          v-model:value="editForm.customerDealAmount"
          :min="0"
          :precision="0"
          :max="999999"
          :placeholder="t('common.pleaseInput')"
        />
      </a-form-item> -->
      <a-form-item name="customerDealNum" :label="t('operate.pphnkg')">
        <a-input-number
          v-model:value="editForm.customerDealNum"
          :precision="0"
          :min="0"
          :max="999999"
          :placeholder="t('common.pleaseInput')"
        />
      </a-form-item>
      <a-form-item name="customerPotentialNum" :label="t('operate.4n7op9')">
        <a-input-number
          v-model:value="editForm.customerPotentialNum"
          :precision="0"
          :min="0"
          :max="999999"
          :placeholder="t('common.pleaseInput')"
        />
      </a-form-item>

      <a-form-item
        name="monthDate"
        :label="t('operate.tnp6po')"
        :rules="[{ required: true, message: t('common.pleaseSelect') }]"
      >
        <a-date-picker v-model:value="editForm.monthDate" picker="month" />
      </a-form-item>
    </a-form>
  </cos-modal>
</template>
<script lang="ts">
import { ref } from 'vue'

import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import { customerConversionTaskSave, customerConversionTaskUpdate } from '@/api/overseasSales/businessRuleSetting'
import type { FormInstance } from 'ant-design-vue'
import { CustomerConversionTaskSaveParams } from '@/typings/api/overseasSales'
import { DcMessage } from '@dc-platform/dc-components'
import dayjs from 'dayjs'
import { useI18n } from 'vue-i18n'

export default { name: 'editModal' }
</script>
<script setup lang="ts">
const { t } = useI18n()
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<CustomerConversionTaskSaveParams>({})
const emit = defineEmits(['success'])
const toggle = (row?: CustomerConversionTaskSaveParams) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
    editForm.value.monthDate = dayjs(row.monthDate)
  } else {
    editForm.value = {}
  }
}

const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true

    try {
      if (editForm.value.id) {
        await customerConversionTaskUpdate({
          ...editForm.value,
          id: editForm.value.id,
          monthDate: dayjs(editForm.value.monthDate).format('YYYY/MM/DD 00:00:00'),
          appId: 'cos_ofbu'
        })
      } else {
        await customerConversionTaskSave({
          ...editForm.value,
          monthDate: dayjs(editForm.value.monthDate).format('YYYY/MM/DD 00:00:00'),
          appId: 'cos_ofbu'
        })
      }
      loading.value = false

      emit('success', editForm.value?.id ? 'edit' : 'add')
      DcMessage.success(editForm.value?.id ? t('operate.mmet2b') : t('operate.ywoekr'))
      toggle()
    } catch (error) {
      loading.value = false
    }
  })
}
defineExpose({
  toggle
})
</script>

<style lang="scss"></style>
